import { render, staticRenderFns } from "./BaseTexteditable.vue?vue&type=template&id=24559398&scoped=true&"
import script from "./BaseTexteditable.vue?vue&type=script&lang=js&"
export * from "./BaseTexteditable.vue?vue&type=script&lang=js&"
import style0 from "./BaseTexteditable.vue?vue&type=style&index=0&id=24559398&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24559398",
  null
  
)

export default component.exports